import { UserProvider } from "./context/UserContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Outlet } from "react-router-dom";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Toaster } from "./components/ui/sonner";
import { toast } from "sonner";
import { useEffect } from "react";
import myAppConfig from "./config";

function App() {
  // Affiche un toast si on a été déconnecté (après redirection)
  useEffect(() => {
    const msg = typeof window !== 'undefined' ? sessionStorage.getItem("auth_toast_msg") : null;
    if (msg) {
      setTimeout(() => toast.error(msg), 0);
      try { sessionStorage.removeItem("auth_toast_msg"); } catch(_) {}
    }
  }, []);

  return (
    <ThemeProvider>
      <UserProvider>
        <GoogleOAuthProvider clientId={myAppConfig.oauth2.GOOGLE_AUTH_CLIENT_ID}>
            <>
              <Outlet />
              <Toaster />
            </>
        </GoogleOAuthProvider>
      </UserProvider>
    </ThemeProvider>
  );
}

export default App;